import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import notificationPopUp from '../../../../NotificationPopUp';

import * as consts from '../../../../constants';

import checkFunctions from '../../../../CheckFunction';

import DocumentsSection from './DocumentsSection';
import ReferentSection from './ReferentSection';
import TextInput from '../../../common/TextInput';
import UserSection from '../../user/UserSection';

import * as authenticationActions from '../../../../actions/authenticationActions';
import * as commonActions from '../../../../actions/commonActions';
import * as networkActions from '../../../../actions/networkActions';
import * as userActions from '../../../../actions/userActions';

class UserPage extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            commonState: this.props.commonState,
            authenticationState: this.props.authenticationState,
            user: props.user,
            networks: [],
            networksForSelect: []
        };

        if (!authenticationActions.verifyAuthentication(this.state.authenticationState, this.props.historyrouter)) {
            return;
        }

        this.caricaDocumento = this.caricaDocumento.bind(this);
        this.eliminaDocumento = this.eliminaDocumento.bind(this);
        this.loadNetworks = this.loadNetworks.bind(this);
        this.saveUser = this.saveUser.bind(this);
        this.updateState = this.updateState.bind(this);
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {
        if (this.state.user.id > -1) {
            this.props.userActions.loadUser(this.state.user.id).then((user) => {
                this.setState(Object.assign({}, this.state, { user: user }));
            }).catch(error => {
                notificationPopUp.error(error);
            });
        }
        if (!this.state.commonState.configuration || this.state.commonState.configuration.cities === null || this.state.commonState.configuration.cities.length === 0) {
            this.props.commonActions.loadConfiguration().then(() => {
            }).catch(error => {
                notificationPopUp.error('Problemi nel caricamento della configurazione base');
            });
        }
        this.loadNetworks();
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.commonState !== prevState.commonState || nextProps.authenticationState !== prevState.authenticationState)
            return Object.assign({}, prevState, { authenticationState: nextProps.authenticationState, commonState: nextProps.commonState });
        return null;
    }

    caricaDocumento(userId, file) {
        return new Promise((resolve, reject) => {
            this.props.userActions.caricaDocumento(userId, file).then((user) => {
                this.setState(Object.assign({}, this.state, { user }));
                resolve('Documento Caricato');
            }).catch(error => {
                reject(error);
            });
        });
    }

    eliminaDocumento(documentoId) {
        return new Promise((resolve, reject) => {
            this.props.userActions.eliminaDocumento(documentoId).then((user) => {
                this.setState(Object.assign({}, this.state, { user }));
                resolve('Documento Eliminato');
            }).catch(error => {
                reject(error);
            });
        });
    }

    loadNetworks() {
        this.props.networkActions.loadAllNetworks().then((networks) => {
            this.setState(Object.assign({}, this.state, {
                networks,
                networksForSelect: networks.map(
                    (value) => {
                        return { value: value.id, text: value.businessName };
                    })
            }));
        }).catch(error => {
            this.setState(Object.assign({}, this.state, { networks: [], networksForSelect: [] }));
            notificationPopUp.error(error);
        });
    }

    saveUser(event) {
        if (this.validate()) {
            this.props.userActions.saveUser(this.state.user).then((newUser) => {
                this.setState(Object.assign({}, this.state, { user: newUser }));
                notificationPopUp.success('Utente ' + newUser.firstName + ' ' + newUser.lastName + ' Salvato');
            }).catch(error => {
                notificationPopUp.error(error);
            });
        } else {
            notificationPopUp.warning('Utente non valido');
        }
    }

    updateState(event) {
        const state = Object.assign({}, this.state);
        var names = event.target.name.split('_');

        if (names[1] === 'role')
            state.user[names[1]] = parseInt(event.target.value, 10);
        else
            state.user[names[1]] = event.target.value;

        this.setState(Object.assign({}, this.state, state));
    }

    validate() {
        const retVal = (!_.isUndefined(this.state.user.firstName) && !_.isEmpty(_.trim(this.state.user.firstName))) &&
            (!_.isUndefined(this.state.user.lastName) && !_.isEmpty(_.trim(this.state.user.lastName))) &&
            (!_.isUndefined(this.state.user.username) && !_.isEmpty(_.trim(this.state.user.username))) &&
            (!_.isUndefined(this.state.user.taxCode) && !_.isEmpty(_.trim(this.state.user.taxCode))) &&
            (checkFunctions.checkCF(this.state.user.taxCode)) &&
            (!_.isUndefined(this.state.user.birthDate) && !_.isEmpty(_.trim(this.state.user.birthDate))) &&
            (!_.isUndefined(this.state.user.emailAddress) && !_.isEmpty(_.trim(this.state.user.emailAddress))) &&
            (checkFunctions.checkEmail(this.state.user.emailAddress)) &&
            (!_.isUndefined(this.state.user.workPhone) && !_.isEmpty(_.trim(this.state.user.workPhone)));

        return retVal;
    }

    render() {
        const title = 'Utente ' + (!_.isUndefined(this.state.user.firstName) ? this.state.user.firstName : '') + ' ' +
            (!_.isUndefined(this.state.user.lastName) ? this.state.user.lastName : '');

        return (
            <div className="container-fluid">
                <h1>{this.state.user.lastName} {this.state.user.firstName}</h1>
                <Row>
                    <Col sm={12}>
                        <button className='btn btn-primary' onClick={() => this.props.history.goBack()} style={{ marginBottom: 10 }} ><span className='glyphicon glyphicon-arrow-left'></span> Indietro</button>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6}>
                        <UserSection authenticationState={this.state.authenticationState} 
                            isAgent={true} title={title}
                            showAllProps={true} userData={this.state.user} onChange={this.updateState} />
                        {this.state.user.role === consts.AUTHENTICATION.USER_ROLE.NetworkReferent ? <div className="panel panel-default x-panel">
                            <div className="panel-heading">Dettagli del Referente</div>
                            <div className="panel-body">
                                <Row>
                                    <Col md={4}>
                                        <TextInput
                                            disabled={this.state.authenticationState.roleId > consts.AUTHENTICATION.USER_ROLE.Seb ? 'disabled' : ''}
                                            name="userData_referenteRights"
                                            label="Rimborso"
                                            value={this.state.user.referenteRights}
                                            onChange={this.updateState} />
                                    </Col>
                                    <Col md={6}>
                                        <TextInput
                                            disabled={this.state.authenticationState.roleId > consts.AUTHENTICATION.USER_ROLE.Seb ? 'disabled' : ''}
                                            isIban={true}
                                            label="IBAN"
                                            name="userData_iban"
                                            onChange={this.updateState}
                                            value={this.state.user.iban} />
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: 10 }}>
                                    <Col md={12}>
                                        <ReferentSection
                                            authenticationState={this.state.authenticationState}
                                            commonState={this.commonState}
                                            networks={this.state.networksForSelect}
                                            userId={this.state.user.id}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </div> : ''}
                        <Row>
                            <Col md={4} mdOffset={4} style={{ marginBottom: 10 }}>
                                <center><Button bsStyle='primary' bsSize="large" disabled={!this.validate()}
                                    onClick={() => this.saveUser()} ><span className='glyphicon glyphicon-floppy-disk'></span> Salva</Button> </center>
                            </Col>
                        </Row>
                    </Col>
                    {authenticationActions.canISeeUserDocuments(this.state.authenticationState, this.state.user) ? <Col md={6}>
                        <DocumentsSection
                            user={this.state.user}
                            caricaDocumento={this.caricaDocumento}
                            eliminaDocumento={this.eliminaDocumento}
                        />
                    </Col> : ''}
                </Row>
            </div>
        );
    }
}

UserPage.propTypes = {
    authenticationState: PropTypes.object.isRequired,
    commonState: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    const user = {
        ateco: '',
        id: ownProps.match.params.id,
        birthDate: new Date().toISOString(),
        code: '',
        companyId: '',
        companyForMaster: '',
        documents: [],
        emailAddress: '',
        emailAddress2: '',
        firstName: '',
        iban: '',
        ivas: '',
        lastName: '',
        username: '',
        password: '',
        sae: '',
        taxCode: '',
        role: consts.AUTHENTICATION.USER_ROLE.NetworkAgent,
        warrantyCoverageCaps: [],
        workPhone: '',
        workPhone2: ''
    };

    return {
        commonState: state.commonState,
        authenticationState: state.authenticationState,
        user: user
    };
}

function mapDispatchToProps(dispatch) {
    return {
        authenticationActions: bindActionCreators(authenticationActions, dispatch),
        commonActions: bindActionCreators(commonActions, dispatch),
        networkActions: bindActionCreators(networkActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserPage);
